var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgArt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 487,
    viewBox: "0 0 414 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_212_502",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 207.525C0.664062 93.4094 93.1728 0.900879 207.288 0.900879C321.403 0.900879 413.912 93.4096 413.912 207.525V280.376C413.912 394.491 321.403 487 207.288 487C93.1728 487 0.664062 394.491 0.664062 280.376V207.525Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 207.525C0.664062 93.4094 93.1728 0.900879 207.288 0.900879C321.403 0.900879 413.912 93.4096 413.912 207.525V280.376C413.912 394.491 321.403 487 207.288 487C93.1728 487 0.664062 394.491 0.664062 280.376V207.525Z",
    fill: "#6ACCD3",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 205.525C0.664062 91.4096 93.1728 -1.09912 207.288 -1.09912H207.288C321.403 -1.09912 413.912 91.4096 413.912 205.525V207.525C413.912 94.5142 321.403 2.90088 207.288 2.90088C93.1728 2.90088 0.664062 94.5142 0.664062 207.525V205.525ZM413.912 487H0.664062H413.912ZM0.664062 487V0.900879V487ZM413.912 0.900879V487V0.900879Z",
    fill: "#1CB5BD",
    mask: "url(#path-1-inside-1_212_502)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgArt2);
export default __webpack_public_path__ + "static/media/bg-art2.d08ccd39301177a397cc46774add0540.svg";
export { ForwardRef as ReactComponent };